import Image from "next/image";

export default function Stores() {
    return (
        <div className={"flex gap-2"}>
            <a href={"https://apps.apple.com/us/app/pup-sports/id6451045273?platform=iphone"} target="_blank">
                <Image
                    src="/images/app-store-badge.svg"
                    alt="App store badge"
                    width={120}
                    height={40}
                />
            </a>
            <a href={"https://play.google.com/store/apps/details?id=pro.getpup.app"}>
                <Image
                    src="/images/google-play-badge.svg"
                    alt="google play badge"
                    width={135}
                    height={40}
                />
            </a>
        </div>
    );
}
